module.exports = __webpack_public_path__ + "img/checked.9136df09.gif";